export default __webpack_public_path__ + "static/media/Group 8517.cb28df0b.svg";